(() => {
  'use strict';

  document
    .querySelectorAll('[data-shoppable-videos]')
    .forEach((section) => {

      if (
        section.dataset.shoppableInitialized === 'true'
      ) {
        return;
      }

      section.dataset.shoppableInitialized = 'true';


      /* =====================================================
         ELEMENTS
         ===================================================== */

      const modal =
        section.querySelector(
          '[data-shoppable-video-modal]'
        );

      const track =
        section.querySelector(
          '[data-video-modal-track]'
        );

      const slides = [
        ...section.querySelectorAll(
          '.shoppable-video-modal__slide'
        )
      ];

      const launcher =
        section.querySelector(
          '[data-video-launcher]'
        );

      const launcherOpen =
        section.querySelector(
          '[data-video-launcher-open]'
        );

      const launcherClose =
        section.querySelector(
          '[data-video-launcher-close]'
        );

      const launcherVideo =
        section.querySelector(
          '.shoppable-video-launcher__video'
        );

      const close =
        section.querySelector(
          '[data-video-modal-close]'
        );

      const prev =
        section.querySelector(
          '[data-video-modal-prev]'
        );

      const next =
        section.querySelector(
          '[data-video-modal-next]'
        );


      if (
        !modal ||
        !track ||
        !slides.length
      ) {
        return;
      }


      /* =====================================================
         STATE
         ===================================================== */

      let active = Number(
        section.dataset.initialVideoIndex || 0
      );

      active = Math.max(
        0,
        Math.min(
          active,
          slides.length - 1
        )
      );


      let startX = 0;
      let startY = 0;

      let mobileScrollTimer = null;


      /* =====================================================
         MOBILE CHECK
         ===================================================== */

      const mobile = () => {

        return window.matchMedia(
          '(max-width: 767px)'
        ).matches;

      };


      /* =====================================================
         PAUSE ALL VIDEOS
         ===================================================== */

      const pauseAll = () => {

        slides.forEach(
          (slide) => {

            const video =
              slide.querySelector(
                'video'
              );

            if (video) {
              video.pause();
            }

          }
        );

      };


      /* =====================================================
         RESET PROGRESS
         ===================================================== */

      const resetProgress = () => {

        slides.forEach(
          (slide) => {

            const bar =
              slide.querySelector(
                '[data-video-progress]'
              );

            if (bar) {
              bar.style.width =
                '0%';
            }

          }
        );

      };


      /* =====================================================
         MUTE ICON SYNC
         ===================================================== */

      const syncMuteControl = (
        slide
      ) => {

        if (!slide) {
          return;
        }


        const video =
          slide.querySelector(
            'video'
          );

        const mute =
          slide.querySelector(
            '[data-video-mute]'
          );


        if (
          !video ||
          !mute
        ) {
          return;
        }


        /*
         * Always use the actual video.muted
         * property as the source of truth.
         */

        const isMuted =
          Boolean(
            video.muted
          );


        mute.classList.toggle(
          'is-muted',
          isMuted
        );

        mute.classList.toggle(
          'is-unmuted',
          !isMuted
        );


        mute.dataset.muted =
          isMuted
            ? 'true'
            : 'false';


        mute.setAttribute(
          'aria-pressed',
          isMuted
            ? 'false'
            : 'true'
        );


        mute.setAttribute(
          'aria-label',
          isMuted
            ? 'Unmute video'
            : 'Mute video'
        );


        const mutedIcon =
          mute.querySelector(
            '[data-mute-icon="muted"]'
          );


        const unmutedIcon =
          mute.querySelector(
            '[data-mute-icon="unmuted"]'
          );


        if (mutedIcon) {

          mutedIcon.hidden =
            !isMuted;

        }


        if (unmutedIcon) {

          unmutedIcon.hidden =
            isMuted;

        }

      };


      /* =====================================================
         PLAY ACTIVE VIDEO
         ===================================================== */

     const playActive = () => {

  pauseAll();
  resetProgress();

  const slide = slides[active];

  if (!slide) {
    return;
  }

  const video = slide.querySelector('video');

  if (!video) {
    return;
  }

  try {
    video.currentTime = 0;
  } catch (_) {}

  video.playsInline = true;

  /*
   * Do NOT force muted here.
   * The modal should open with audio enabled.
   */
  video.muted = false;

  syncMuteControl(slide);

  const playPromise = video.play();

  if (
    playPromise &&
    typeof playPromise.catch === 'function'
  ) {
    playPromise.catch(() => {});
  }
};


      /* =====================================================
         POSITION DESKTOP / MOBILE
         ===================================================== */

      const position = () => {

        /*
         * Mobile uses native vertical
         * scroll-snap.
         */

        if (mobile()) {

          slides.forEach(
            (slide, index) => {

              slide.classList.toggle(
                'is-active',
                index === active
              );

              slide.classList.remove(
                'is-prev',
                'is-next'
              );

            }
          );

          return;

        }


        /*
         * Desktop carousel.
         */

        slides.forEach(
          (slide, index) => {

            slide.classList.toggle(
              'is-active',
              index === active
            );

            slide.classList.toggle(
              'is-prev',
              index === active - 1
            );

            slide.classList.toggle(
              'is-next',
              index === active + 1
            );

          }
        );


        if (prev) {

          prev.classList.toggle(
            'is-disabled',
            active === 0
          );

        }


        if (next) {

          next.classList.toggle(
            'is-disabled',
            active ===
              slides.length - 1
          );

        }

      };


      /* =====================================================
         MOBILE SCROLL TO ACTIVE SLIDE
         ===================================================== */

      const scrollMobileToSlide = (
        index,
        behavior = 'auto'
      ) => {

        if (!mobile()) {
          return;
        }


        if (!track) {
          return;
        }


        const slide =
          slides[index];


        if (!slide) {
          return;
        }


        /*
         * IMPORTANT:
         *
         * Use the actual slide offset rather
         * than assuming every slide is exactly
         * the same height as the track.
         *
         * This makes the initial position
         * reliable on mobile.
         */

        const top =
          slide.offsetTop;


        track.scrollTo({
          top,
          behavior
        });

      };


      /* =====================================================
         SYNC ACTIVE INDEX FROM MOBILE SCROLL
         ===================================================== */

      const syncMobileFromScroll = () => {

        if (!mobile()) {
          return;
        }


        if (
          !modal.classList.contains(
            'is-open'
          )
        ) {
          return;
        }


        if (!slides.length) {
          return;
        }


        const scrollPosition =
          track.scrollTop;


        /*
         * Find the slide closest to the
         * current scroll position.
         *
         * This is safer than:
         *
         * scrollTop / track.clientHeight
         *
         * because slide heights/margins can
         * differ between devices.
         */

        let closestIndex =
          active;

        let closestDistance =
          Infinity;


        slides.forEach(
          (slide, index) => {

            const distance =
              Math.abs(
                slide.offsetTop -
                scrollPosition
              );


            if (
              distance <
              closestDistance
            ) {

              closestDistance =
                distance;

              closestIndex =
                index;

            }

          }
        );


        const nextIndex =
          Math.max(
            0,
            Math.min(
              closestIndex,
              slides.length - 1
            )
          );


        if (
          nextIndex ===
          active
        ) {
          return;
        }


        active =
          nextIndex;


        position();

        playActive();

      };


      /* =====================================================
         MOBILE SCROLL LISTENER
         ===================================================== */

      track.addEventListener(
        'scroll',
        () => {

          if (!mobile()) {
            return;
          }


          clearTimeout(
            mobileScrollTimer
          );


          mobileScrollTimer =
            setTimeout(
              syncMobileFromScroll,
              100
            );

        },
        {
          passive: true
        }
      );


      /* =====================================================
         GO TO SLIDE
         ===================================================== */

      const go = (
        index
      ) => {

        const nextIndex =
          Math.max(
            0,
            Math.min(
              index,
              slides.length - 1
            )
          );


        if (
          nextIndex ===
          active
        ) {

          if (mobile()) {

            scrollMobileToSlide(
              nextIndex,
              'smooth'
            );

          }

          return;

        }


        active =
          nextIndex;


        position();


        /*
         * Mobile:
         * scroll to the selected slide.
         */

        if (mobile()) {

          scrollMobileToSlide(
            nextIndex,
            'smooth'
          );

        }


        playActive();

      };


      /* =====================================================
         HIDE LAUNCHER
         ===================================================== */

      const hideLauncher = () => {

        if (!launcher) {
          return;
        }


        /*
         * !important is intentional.
         *
         * Your mobile CSS gives the launcher
         * display/visibility rules, so a normal
         * inline display:none can still lose to
         * a CSS !important declaration.
         */

        launcher.style.setProperty(
          'display',
          'none',
          'important'
        );


        launcher.setAttribute(
          'aria-hidden',
          'true'
        );

      };


      /* =====================================================
         SHOW LAUNCHER
         ===================================================== */

      const showLauncher = () => {

        if (!launcher) {
          return;
        }


        launcher.style.removeProperty(
          'display'
        );


        launcher.removeAttribute(
          'aria-hidden'
        );

      };


      /* =====================================================
         OPEN MODAL
         ===================================================== */

      const open = (index = 0) => {

  active = Math.max(
    0,
    Math.min(
      Number(index) || 0,
      slides.length - 1
    )
  );

  hideLauncher();

  modal.classList.add('is-open');

  modal.setAttribute(
    'aria-hidden',
    'false'
  );

  document.documentElement.classList.add(
    'shoppable-video-modal-open'
  );

  document.body.style.overflow = 'hidden';

  /*
   * Set the correct active slide first.
   */
  position();

  /*
   * On mobile, position the modal at
   * the correct product video.
   */
  if (mobile()) {
    scrollMobileToSlide(
      active,
      'auto'
    );
  }

  /*
   * Start the video immediately from
   * the user's modal-opening interaction.
   */
  playActive();

};

      /* =====================================================
         CLOSE MODAL
         ===================================================== */

      const shut = () => {

        pauseAll();

        resetProgress();


        modal.classList.remove(
          'is-open'
        );


        modal.setAttribute(
          'aria-hidden',
          'true'
        );


        document.documentElement.classList.remove(
          'shoppable-video-modal-open'
        );


        document.body.style.overflow =
          '';


        /*
         * Restore the floating launcher.
         */

        showLauncher();

      };


      /* =====================================================
         LAUNCHER OPEN
         ===================================================== */

      if (launcherOpen) {

        launcherOpen.addEventListener(
          'click',
          (event) => {

            event.preventDefault();

            event.stopPropagation();


            const initialIndex =
              Number(
                section.dataset.initialVideoIndex ||
                0
              );


            /*
             * Use the same index that
             * generated the launcher video.
             */

            open(
              initialIndex
            );

          }
        );

      }


      /*
       * IMPORTANT:
       *
       * There is intentionally NO separate
       * mobile touchend handler here.
       *
       * The previous code had:
       *
       * open(0)
       *
       * inside touchend.
       *
       * That was forcing mobile to video 0
       * after the click handler had already
       * opened the correct active video.
       */


      /* =====================================================
         LAUNCHER CLOSE
         ===================================================== */

      if (launcherClose) {

        launcherClose.addEventListener(
          'click',
          (event) => {

            event.preventDefault();

            event.stopPropagation();


            if (launcher) {

              launcher.remove();

            }

          }
        );

      }


      /* =====================================================
         MODAL CLOSE
         ===================================================== */

      if (close) {

        close.addEventListener(
          'click',
          (event) => {

            event.preventDefault();

            event.stopPropagation();

            shut();

          }
        );

      }


      /* =====================================================
         PREVIOUS
         ===================================================== */

      if (prev) {

        prev.addEventListener(
          'click',
          (event) => {

            event.preventDefault();

            event.stopPropagation();

            go(
              active - 1
            );

          }
        );

      }


      /* =====================================================
         NEXT
         ===================================================== */

      if (next) {

        next.addEventListener(
          'click',
          (event) => {

            event.preventDefault();

            event.stopPropagation();

            go(
              active + 1
            );

          }
        );

      }


      /* =====================================================
         VIDEO EVENTS
         ===================================================== */

      slides.forEach(
        (slide) => {

          const video =
            slide.querySelector(
              'video'
            );


          const bar =
            slide.querySelector(
              '[data-video-progress]'
            );


          if (!video) {
            return;
          }


          /*
           * Keep the mute button synchronized
           * with the actual video state.
           */

          video.addEventListener(
            'volumechange',
            () => {

              syncMuteControl(
                slide
              );

            }
          );


          /*
           * VIDEO PROGRESS
           */

          video.addEventListener(
            'timeupdate',
            () => {

              if (
                slide !==
                slides[active]
              ) {
                return;
              }


              if (
                !video.duration ||
                !isFinite(
                  video.duration
                )
              ) {
                return;
              }


              const percentage =
                (
                  video.currentTime /
                  video.duration
                ) * 100;


              if (bar) {

                bar.style.width =
                  `${percentage}%`;

              }

            }
          );


          /*
           * VIDEO ENDED
           */

          video.addEventListener(
            'ended',
            () => {

              if (
                slide !==
                slides[active]
              ) {
                return;
              }


              if (
                active <
                slides.length - 1
              ) {

                go(
                  active + 1
                );

              }

            }
          );

        }
      );


      /* =====================================================
         LIKE / SHARE / MUTE
         ===================================================== */

      section.addEventListener(
        'click',
        async (event) => {

          const like =
            event.target.closest(
              '[data-video-like]'
            );


          const share =
            event.target.closest(
              '[data-video-share]'
            );


          const mute =
            event.target.closest(
              '[data-video-mute]'
            );


          if (
            !like &&
            !share &&
            !mute
          ) {
            return;
          }


          event.preventDefault();

          event.stopPropagation();


          /* -------------------------------------------------
             LIKE
             ------------------------------------------------- */

          if (like) {

            const liked =
              !like.classList.contains(
                'is-liked'
              );


            like.classList.toggle(
              'is-liked',
              liked
            );


            like.setAttribute(
              'aria-pressed',
              liked
                ? 'true'
                : 'false'
            );


            const icon =
              like.querySelector(
                '.shoppable-video-control__icon'
              );


            if (icon) {

              icon.textContent =
                liked
                  ? '♥'
                  : '♡';

            }


            return;

          }


          /* -------------------------------------------------
             MUTE
             ------------------------------------------------- */

          if (mute) {

  const slide =
    mute.closest(
      '.shoppable-video-modal__slide'
    );

  const video =
    slide?.querySelector(
      'video'
    );

  if (!video) {
    return;
  }

  /*
   * Toggle the actual video audio state.
   */
  video.muted = !video.muted;

  /*
   * Force the browser to apply the
   * updated audio state on mobile.
   */
  if (video.muted) {
    video.setAttribute('muted', '');
  } else {
    video.removeAttribute('muted');
  }

  /*
   * Keep the button/icon synchronized.
   */
  syncMuteControl(slide);

  return;
}


          /* -------------------------------------------------
             SHARE
             ------------------------------------------------- */

          if (share) {

            const url =
              window.location.href;


            const title =
              document.title;


            /*
             * Native mobile share.
             */

            if (
              typeof navigator.share ===
              'function'
            ) {

              try {

                await navigator.share({
                  title,
                  url
                });

              } catch (_) {}


              return;

            }


            /*
             * Clipboard fallback.
             */

            try {

              if (
                navigator.clipboard &&
                typeof navigator
                  .clipboard
                  .writeText ===
                  'function'
              ) {

                await navigator.clipboard.writeText(
                  url
                );


                const icon =
                  share.querySelector(
                    '.shoppable-video-control__icon'
                  );


                if (icon) {

                  const original =
                    icon.textContent;


                  icon.textContent =
                    '✓';


                  setTimeout(
                    () => {

                      icon.textContent =
                        original;

                    },
                    1500
                  );

                }


                share.classList.add(
                  'is-shared'
                );


                setTimeout(
                  () => {

                    share.classList.remove(
                      'is-shared'
                    );

                  },
                  1500
                );


                return;

              }

            } catch (_) {}


            /*
             * Final fallback.
             */

            window.prompt(
              'Copy this link:',
              url
            );

          }

        },
        true
      );


      /* =====================================================
         ADD TO CART + SIZE PICKER
         ===================================================== */

      /* =========================================================
         STYLE + SIZE PICKER DATA
         ========================================================= */

      const getStyles = (form) => {

        return [
          ...form.querySelectorAll(
            '[data-shoppable-style]'
          )
        ].map((style) => {

          const variants = [
            ...style.querySelectorAll(
              '.shoppable-video-variant-option'
            )
          ].map((option) => ({
            id:
              option.dataset.variantId,

            title:
              option.dataset.variantTitle ||
              option.textContent.trim()
          }));


          return {
            productId:
              style.dataset.productId,

            title:
              style.dataset.productTitle,

            url:
              style.dataset.productUrl,

            image:
              style.dataset.productImage,

            variants

          };

        });

      };


      /* =========================================================
         GET VARIANTS FOR ONE SELECTED STYLE
         ========================================================= */

      const getAvailableVariants = (
        form,
        styleIndex = 0
      ) => {

        const styles =
          getStyles(form);


        if (
          !styles.length ||
          !styles[styleIndex]
        ) {

          return [];

        }


        return styles[
          styleIndex
        ].variants || [];

      };


      /* =========================================================
         OPEN STYLE + SIZE PICKER
         ========================================================= */

      const openSizePicker = (
        form
      ) => {

        const picker =
          form.querySelector(
            '[data-shoppable-size-picker]'
          );


        const optionsContainer =
          form.querySelector(
            '[data-size-picker-options]'
          );


        const confirmButton =
          form.querySelector(
            '[data-size-picker-confirm]'
          );


        if (
          !picker ||
          !optionsContainer ||
          !confirmButton
        ) {

          console.warn(
            '[Toprico] Size picker elements not found.'
          );

          return false;

        }


        const styles =
          getStyles(form);


        if (!styles.length) {

          console.warn(
            '[Toprico] No shoppable styles found.'
          );

          return false;

        }


        /*
         * The first style is the current product.
         */

        let selectedStyleIndex =
          0;


        let selectedVariantId =
          null;


        /* =======================================================
           RENDER PICKER
           ======================================================= */

        const renderPicker = () => {

          optionsContainer.innerHTML =
            '';


          /* =====================================================
             STYLE HEADING
             ===================================================== */

          const styleHeading =
            document.createElement(
              'div'
            );


          styleHeading.className =
            'shoppable-size-picker__section-title';


          styleHeading.textContent =
            'Select Style';


          optionsContainer.appendChild(
            styleHeading
          );


          /* =====================================================
             STYLE OPTIONS
             ===================================================== */

          const styleOptions =
            document.createElement(
              'div'
            );


          styleOptions.className =
            'shoppable-size-picker__style-options';


          styles.forEach(
            (style, index) => {

              const styleButton =
                document.createElement(
                  'button'
                );


              styleButton.type =
                'button';


              styleButton.className =
                'shoppable-size-picker__style-option';


              if (
                index ===
                selectedStyleIndex
              ) {

                styleButton.classList.add(
                  'is-selected'
                );

              }


              styleButton.setAttribute(
                'aria-pressed',
                index ===
                  selectedStyleIndex
                  ? 'true'
                  : 'false'
              );


              /*
               * Text only — no image.
               */

              styleButton.textContent =
                style.title;


              styleButton.addEventListener(
                'click',
                () => {

                  selectedStyleIndex =
                    index;


                  selectedVariantId =
                    null;


                  form.removeAttribute(
                    'data-selected-size-variant'
                  );


                  form.removeAttribute(
                    'data-selected-style-product'
                  );


                  confirmButton.disabled =
                    true;


                  renderPicker();

                }
              );


              styleOptions.appendChild(
                styleButton
              );

            }
          );


          optionsContainer.appendChild(
            styleOptions
          );


          /* =====================================================
             SIZE HEADING
             ===================================================== */

          const sizeHeading =
            document.createElement(
              'div'
            );


          sizeHeading.className =
            'shoppable-size-picker__section-title';


          sizeHeading.textContent =
            'Select Size';


          optionsContainer.appendChild(
            sizeHeading
          );


          /* =====================================================
             SIZE OPTIONS
             ===================================================== */

          const sizeOptions =
            document.createElement(
              'div'
            );


          sizeOptions.className =
            'shoppable-size-picker__size-options';


          const variants =
            getAvailableVariants(
              form,
              selectedStyleIndex
            );


          /*
           * Only available variants were
           * rendered by Liquid, so sold-out
           * sizes are not rendered here.
           */

          variants.forEach(
            (variant) => {

              const sizeButton =
                document.createElement(
                  'button'
                );


              sizeButton.type =
                'button';


              sizeButton.className =
                'shoppable-size-picker__option';


              sizeButton.dataset.variantId =
                variant.id;


              sizeButton.dataset.variantTitle =
                variant.title;


              sizeButton.setAttribute(
                'aria-pressed',
                'false'
              );


              sizeButton.textContent =
                variant.title;


              sizeButton.addEventListener(
                'click',
                () => {

                  /*
                   * Remove previous size selection.
                   */

                  sizeOptions
                    .querySelectorAll(
                      '.shoppable-size-picker__option'
                    )
                    .forEach(
                      (option) => {

                        option.classList.remove(
                          'is-selected'
                        );


                        option.setAttribute(
                          'aria-pressed',
                          'false'
                        );

                      }
                    );


                  /*
                   * Select this size.
                   */

                  sizeButton.classList.add(
                    'is-selected'
                  );


                  sizeButton.setAttribute(
                    'aria-pressed',
                    'true'
                  );


                  selectedVariantId =
                    variant.id;


                  /*
                   * Store selected Shopify
                   * variant ID.
                   */

                  form.dataset.selectedSizeVariant =
                    variant.id;


                  /*
                   * Store selected product.
                   */

                  form.dataset.selectedStyleProduct =
                    styles[
                      selectedStyleIndex
                    ].productId;


                  /*
                   * Enable Add to Cart.
                   */

                  confirmButton.disabled =
                    false;

                }
              );


              sizeOptions.appendChild(
                sizeButton
              );

            }
          );


          optionsContainer.appendChild(
            sizeOptions
          );


          /*
           * If the selected style has no
           * available sizes, keep Add to Cart
           * disabled.
           */

          if (
            !variants.length
          ) {

            const noSizes =
              document.createElement(
                'div'
              );


            noSizes.className =
              'shoppable-size-picker__no-sizes';


            noSizes.textContent =
              'No sizes currently available';


            optionsContainer.appendChild(
              noSizes
            );


            confirmButton.disabled =
              true;

          }

        };


        /* =======================================================
           INITIAL RENDER
           ======================================================= */

        renderPicker();


        /* =======================================================
           OPEN PICKER
           ======================================================= */

        picker.hidden =
          false;


        picker.setAttribute(
          'aria-hidden',
          'false'
        );


        document.documentElement.classList.add(
          'shoppable-size-picker-open'
        );


        document.body.classList.add(
          'shoppable-size-picker-open'
        );


        /*
         * Focus first style button.
         */

        requestAnimationFrame(
          () => {

            const firstStyle =
              optionsContainer.querySelector(
                '.shoppable-size-picker__style-option'
              );


            if (
              firstStyle
            ) {

              firstStyle.focus();

            }

          }
        );


        return true;

      };


      const closeSizePicker = (
        form
      ) => {

        const picker =
          form.querySelector(
            '[data-shoppable-size-picker]'
          );


        if (!picker) {

          return;

        }


        picker.hidden =
          true;


        picker.setAttribute(
          'aria-hidden',
          'true'
        );


        form.removeAttribute(
          'data-selected-size-variant'
        );


        document.documentElement.classList.remove(
          'shoppable-size-picker-open'
        );


        document.body.classList.remove(
          'shoppable-size-picker-open'
        );

      };


      section.addEventListener(
        'submit',
        async (event) => {

          const form =
            event.target.closest(
              '[data-shoppable-add-to-cart]'
            );


          if (!form) {

            return;

          }


          /*
           * If the customer has already
           * selected a size, continue to
           * normal cart logic.
           */

          const selectedVariantId =
            form.dataset.selectedSizeVariant;


          /*
           * If no variant has been selected,
           * check available variants.
           */

          if (!selectedVariantId) {

            const variants =
              getAvailableVariants(
                form
              );


            /*
             * More than one available variant:
             * open size picker.
             */

            if (
              variants.length > 1
            ) {

              event.preventDefault();

              event.stopImmediatePropagation();


              openSizePicker(
                form
              );


              return;

            }

          }


          /*
           * Existing cart logic.
           */

          event.preventDefault();

          event.stopPropagation();


          const button =
            form.querySelector(
              '.shoppable-video-product-card__add'
            );


          const text =
            form.querySelector(
              '.shoppable-video-product-card__add-text'
            );


          const loading =
            form.querySelector(
              '.shoppable-video-product-card__add-loading'
            );


          const input =
            form.querySelector(
              'input[name="id"]'
            );


          if (
            !button ||
            !input
          ) {

            return;

          }


          /*
           * If a size was selected,
           * replace the hidden variant ID.
           */

          if (
            selectedVariantId
          ) {

            input.value =
              selectedVariantId;

          }


          if (!input.value) {

            return;

          }


          if (
            button.dataset.processing ===
            'true'
          ) {

            return;

          }


          const variantId =
            Number(
              input.value
            );


          if (
            !Number.isFinite(
              variantId
            ) ||
            variantId <= 0
          ) {

            console.error(
              '[Toprico] Invalid variant ID:',
              input.value
            );

            return;

          }


          /*
           * START
           */

          button.dataset.processing =
            'true';


          button.disabled =
            true;


          button.classList.add(
            'is-loading'
          );


          if (text) {

            text.style.display =
              'none';

          }


          if (loading) {

            loading.style.display =
              'inline';

            loading.textContent =
              'ADDING...';

          }


          try {

            const root =
              window.Shopify?.routes
                ?.root ||
              '/';


            const response =
              await fetch(
                `${root}cart/add.js`,
                {
                  method:
                    'POST',

                  headers: {
                    'Content-Type':
                      'application/json',

                    'Accept':
                      'application/json'
                  },

                  body:
                    JSON.stringify({
                      items: [
                        {
                          id:
                            variantId,

                          quantity:
                            1
                        }
                      ]
                    })
                }
              );


            let data = {};


            try {

              data =
                await response.json();

            } catch (_) {}


            if (!response.ok) {

              throw new Error(
                data.description ||
                data.message ||
                'Unable to add product to cart.'
              );

            }


            /*
             * SUCCESS
             */

            if (loading) {

              loading.style.display =
                'inline';

              loading.textContent =
                'ADDED TO CART';

            }


            document.dispatchEvent(
              new CustomEvent(
                'shoppable:cart-added',
                {
                  bubbles:
                    true,

                  detail: {
                    item:
                      data.items?.[0] ||
                      null
                  }
                }
              )
            );


            /*
             * Refresh cart.
             */

            try {

              const cartResponse =
                await fetch(
                  `${root}cart.js`,
                  {
                    headers: {
                      Accept:
                        'application/json'
                    },

                    cache:
                      'no-store'
                  }
                );


              if (
                cartResponse.ok
              ) {

                const cart =
                  await cartResponse.json();


                document.dispatchEvent(
                  new CustomEvent(
                    'cart:refresh',
                    {
                      bubbles:
                        true,

                      detail: {
                        cart
                      }
                    }
                  )
                );

              }

            } catch (
              cartError
            ) {

              console.warn(
                '[Toprico] Cart refresh failed:',
                cartError
              );

            }


            /*
             * Keep existing success timing.
             */

            await new Promise(
              (resolve) => {

                setTimeout(
                  resolve,
                  1000
                );

              }
            );


            /*
             * RESET
             */

            button.disabled =
              false;


            button.dataset.processing =
              'false';


            button.classList.remove(
              'is-loading',
              'is-error',
              'is-added'
            );


            if (loading) {

              loading.style.display =
                'none';

              loading.textContent =
                'ADDING...';

            }


            if (text) {

              text.style.display =
                'inline';

              text.textContent =
                'ADD TO CART';

            }


            /*
             * Clear selected variant
             * after successful add.
             */

            delete form.dataset.selectedSizeVariant;


          } catch (
            error
          ) {

            console.error(
              '[Toprico Shoppable Videos] Add to cart failed:',
              error
            );


            button.classList.remove(
              'is-loading'
            );


            button.classList.add(
              'is-error'
            );


            if (loading) {

              loading.style.display =
                'none';

              loading.textContent =
                'ADDING...';

            }


            if (text) {

              text.style.display =
                'inline';


              if (
                error.message &&
                error.message.includes(
                  'maximum quantity'
                )
              ) {

                text.textContent =
                  'ALREADY IN CART';

              } else {

                text.textContent =
                  'TRY AGAIN';

              }

            }


            button.disabled =
              false;


            button.dataset.processing =
              'false';


            setTimeout(
              () => {

                button.classList.remove(
                  'is-error'
                );


                if (text) {

                  text.textContent =
                    'ADD TO CART';

                }

              },
              1800
            );

          }

        },
        true
      );


      /* =========================================================
         SIZE PICKER CLOSE
         ========================================================= */

      section.addEventListener(
        'click',
        (event) => {

          const closeButton =
            event.target.closest(
              '[data-size-picker-close]'
            );


          if (!closeButton) {

            return;

          }


          const form =
            closeButton.closest(
              '[data-shoppable-add-to-cart]'
            );


          if (!form) {

            return;

          }


          event.preventDefault();

          event.stopPropagation();


          closeSizePicker(
            form
          );

        },
        true
      );


      /* =========================================================
         SIZE PICKER CONFIRM
         ========================================================= */

      section.addEventListener(
        'click',
        (event) => {

          const confirmButton =
            event.target.closest(
              '[data-size-picker-confirm]'
            );


          if (!confirmButton) {

            return;

          }


          const form =
            confirmButton.closest(
              '[data-shoppable-add-to-cart]'
            );


          if (!form) {

            return;

          }


          const selectedVariantId =
            form.dataset.selectedSizeVariant;


          if (!selectedVariantId) {

            return;

          }


          event.preventDefault();

          event.stopPropagation();


          const input =
            form.querySelector(
              'input[name="id"]'
            );


          if (!input) {

            return;

          }


          /*
           * Set actual Shopify variant.
           */

          input.value =
            selectedVariantId;


          /*
           * Close picker.
           */

          closeSizePicker(
            form
          );


          /*
           * Mark submission as coming
           * from size picker.
           */

          form.dataset.selectedSizeVariant =
            selectedVariantId;


          /*
           * Trigger same form submission.
           */

          if (
            typeof form.requestSubmit ===
            'function'
          ) {

            form.requestSubmit();

          } else {

            form.dispatchEvent(
              new Event(
                'submit',
                {
                  bubbles:
                    true,

                  cancelable:
                    true
                }
              )
            );

          }

        },
        true
      );


      /* =====================================================
         BACKDROP
         ===================================================== */

      modal.addEventListener(
        'click',
        (event) => {

          if (
            event.target ===
            modal
          ) {

            shut();

          }

        }
      );


      /* =====================================================
         KEYBOARD
         ===================================================== */

      document.addEventListener(
        'keydown',
        (event) => {

          if (
            !modal.classList.contains(
              'is-open'
            )
          ) {

            return;

          }


          if (
            event.key ===
            'Escape'
          ) {

            shut();

            return;

          }


          if (
            event.key ===
            'ArrowRight'
          ) {

            go(
              active + 1
            );

            return;

          }


          if (
            event.key ===
            'ArrowLeft'
          ) {

            go(
              active - 1
            );

          }

        }
      );


      /* =====================================================
         DESKTOP HORIZONTAL SWIPE
         ===================================================== */

      track.addEventListener(
        'pointerdown',
        (event) => {

          if (mobile()) {
            return;
          }


          startX =
            event.clientX;

          startY =
            event.clientY;

        }
      );


      track.addEventListener(
        'pointerup',
        (event) => {

          if (mobile()) {
            return;
          }


          const dx =
            event.clientX -
            startX;


          const dy =
            event.clientY -
            startY;


          if (
            Math.abs(dx) <
              60 ||
            Math.abs(dx) <
              Math.abs(dy)
          ) {

            return;

          }


          go(
            dx < 0
              ? active + 1
              : active - 1
          );

        }
      );


      /* =====================================================
         LAUNCHER VIDEO
         ===================================================== */

      if (launcherVideo) {

        const updateLauncher =
          () => {

            if (mobile()) {

              launcherVideo.muted =
                true;

              launcherVideo.playsInline =
                true;


              const promise =
                launcherVideo.play();


              if (
                promise &&
                typeof promise.catch ===
                  'function'
              ) {

                promise.catch(
                  () => {}
                );

              }

            } else {

              launcherVideo.pause();


              try {

                launcherVideo.currentTime =
                  0;

              } catch (_) {}

            }

          };


        updateLauncher();


        window.addEventListener(
          'resize',
          updateLauncher
        );

      }


      /* =====================================================
         INITIAL STATE
         ===================================================== */

      position();


      /*
       * Synchronize initial mute icons
       * with the actual video state.
       */

      slides.forEach(
        (slide) => {

          syncMuteControl(
            slide
          );

        }
      );

    });

})();